<template>
  <div class="ticket-page">
    <van-icon name="passed" size="60" color="#07c160" />
    <div class="text">支付已完成</div>
    <!-- 按钮文案建议改为"返回商家"或"查看订单"，比"返回"更明确 -->
    <van-button type="primary" round block @click="goToPayLoading">
      返回商家
    </van-button>
  </div>
</template>

<script>
import {
  Toast
} from 'vant'

const WX_PAY_URL = 'https://payapp.weixin.qq.com'

export default {
  name: 'MerchantTicket',
  data () {
    return {
      outTradeNo: ''
    }
  },
  mounted () {
    const params = new URLSearchParams(window.location.search)
    this.outTradeNo = params.get('out_trade_no') || ''
    if (!this.outTradeNo && window.location.hash.includes('?')) {
      const hashQuery = window.location.hash.split('?')[1]
      const hashParams = new URLSearchParams(hashQuery)
      this.outTradeNo = hashParams.get('out_trade_no') || ''
    }
    // 没有这行代码，微信就会报"无法获取订单信息"
    const readyData = {
      action: 'onIframeReady',
      displayStyle: 'SHOW_CUSTOM_PAGE'
    }
    window.parent.postMessage(JSON.stringify(readyData), WX_PAY_URL)
  },
  methods: {
    goToPayLoading () {
      // 默认兜底首页（静默降级，不给用户任何技术提示）
      let targetUrl = 'https://wx.qianbaokj.cn/#/QueryRecharge'

      // 有订单号才覆盖为详情页，无参数则直接使用默认的首页地址
      if (this.outTradeNo) {
        targetUrl = `https://wx.qianbaokj.cn/#/PayV2Loading/${this.outTradeNo}`
      }

      // 统一展示跳转过渡态（只描述行为，不暴露内部状态）
      const loading = Toast.loading({
        message: '正在跳转...',
        forbidClick: true,
        duration: 0
      })

      try {
        window.parent.postMessage(
          JSON.stringify({ action: 'jumpOut', jumpOutUrl: targetUrl }),
          'https://payapp.weixin.qq.com'
        )
      } catch (e) {
        // 仅保留开发调试日志，不对用户展示
        console.error('[Ticket] postMessage failed:', e)
      }

      // 平滑过渡到微信原生确认弹窗
      setTimeout(() => {
        loading.close()
      }, 1000)
    }
  }
}
</script>

<style scoped lang="less">
  .ticket-page {
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 80px;
    background-color: #F7F8FA;
  }

  .text {
    margin: 20px 0 40px;
    font-size: 16px;
    color: #333;
    font-weight: 500;
  }

  .van-button {
    width: 80%;
  }
</style>
